import { a as _slicedToArray, e as _extends } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PropertiesList from './PropertiesList.js';
import { I as Icon } from './index-11bc5ac3.js';
import Popup from './Popup.js';
import Divider from './Divider.js';
import MapLayoutGoogle from './MapLayoutGoogle.js';
import { u as useComponentWidth } from './useComponentWidth-dbdc6efa.js';
import Paginator from './Paginator.js';
import DropdownMenu from './DropdownMenu.js';
import { c as currencyShape, e as multiPropertyOfferShape, g as feedbackMessagesShape, f as formattedSearchParamsShape, h as trustYouReducerShape, n as nodeOrStringProp, p as paginationShape, j as sortByMenuItemShape, k as propertiesFiltersShape } from './PropTypes-e1e509ba.js';
import Modal from './Modal.js';
import { B as Button } from './Button-a16585e5.js';
import { P as PortalFilters, p as portalFiltersShape, a as alternativeOffersShape } from './index-8f601c6e.js';
import { a as alternativeOffersLabelsShape } from './index-4e1cd670.js';
import { C as Card } from './Card-003e3c50.js';
import './usePrevious-edd83563.js';
import './Title.js';
import './EmptySectionMessage.js';
import './Image.js';
import 'moment';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './tslib.es6-2748fcb6.js';
import './_commonjsHelpers-17042db9.js';
import './MapView.js';
import './Location.js';
import './AmenitiesList.js';
import './Description.js';
import './Price.js';
import './index-f48c5efa.js';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';
import './provider-936ecd10.js';
import './Label.js';
import './utilsHelpers-e4b21f4b.js';
import './LoadingBlock.js';
import './PropertyRating.js';
import './LoadingSpinner.js';
import './handleOpenLink-49ba3691.js';
import './Select.js';
import './useKeyPress-dea8da08.js';
import './useWindowSize-0dc36789.js';
import './PropertiesFilterByName.js';
import './SearchInput.js';
import './Input.js';
import './Checkbox.js';
import 'rc-slider';

function PropertiesLayout(props) {
  var _propertiesLayoutRef$;
  var className = props.className,
    displayMode = props.displayMode,
    alternativeGrid = props.alternativeGrid,
    labelsMapLayout = props.labelsMapLayout,
    propertyCardProps = props.propertyCardProps,
    availableLayouts = props.availableLayouts,
    availableProperties = props.availableProperties,
    notAvailableProperties = props.notAvailableProperties,
    language = props.language,
    isLoading = props.isLoading,
    error = props.error,
    onClick = props.onClick,
    params = props.params,
    feedbackMessages = props.feedbackMessages,
    domain = props.domain,
    getQueryString = props.getQueryString,
    trustYou = props.trustYou,
    selectorViewAvailable = props.selectorViewAvailable,
    styledPrice = props.styledPrice,
    onChangePage = props.onChangePage,
    priceRangeMax = props.priceRangeMax,
    priceRangeMin = props.priceRangeMin,
    onFilterProperties = props.onFilterProperties,
    onChangeSearchInput = props.onChangeSearchInput,
    onFilterPrice = props.onFilterPrice,
    onFilterCheckboxes = props.onFilterCheckboxes,
    resetAutocompleteFilters = props.resetAutocompleteFilters,
    setAutocompleteFilter = props.setAutocompleteFilter,
    autocompleteFilterApplied = props.autocompleteFilterApplied,
    filters = props.filters,
    showFilters = props.showFilters,
    onPropertiesRendered = props.onPropertiesRendered,
    filterDataAndLabels = props.filterDataAndLabels,
    priceMessages = props.priceMessages,
    widgetId = props.widgetId,
    onChangePageSize = props.onChangePageSize,
    pagination = props.pagination,
    paginatorReferenceLabel = props.paginatorReferenceLabel,
    paginatorPageSizeMessage = props.paginatorPageSizeMessage,
    viewAsLabel = props.viewAsLabel,
    sortBy = props.sortBy,
    sortByMenuItems = props.sortByMenuItems,
    userCountry = props.userCountry,
    onGetPlace = props.onGetPlace,
    isQA = props.isQA,
    hidePrices = props.hidePrices,
    hidePricesMessage = props.hidePricesMessage,
    intl = props.intl,
    portalFilters = props.portalFilters,
    showAlternativeOffers = props.showAlternativeOffers,
    alternativeOffersConfig = props.alternativeOffersConfig,
    toggleAlternativeOffers = props.toggleAlternativeOffers,
    alternativeOffersLabels = props.alternativeOffersLabels;
  var initialLayout = availableLayouts.includes(displayMode) ? displayMode : availableLayouts[0];
  var _useState = useState(initialLayout),
    _useState2 = _slicedToArray(_useState, 2),
    currentLayout = _useState2[0],
    setCurrentLayout = _useState2[1];
  var _useComponentWidth = useComponentWidth(),
    _useComponentWidth2 = _slicedToArray(_useComponentWidth, 2),
    propertiesLayoutRef = _useComponentWidth2[0],
    propertiesLayoutWidth = _useComponentWidth2[1];
  var _useState3 = useState(((_propertiesLayoutRef$ = propertiesLayoutRef.current) === null || _propertiesLayoutRef$ === void 0 ? void 0 : _propertiesLayoutRef$.clientWidth) >= 768),
    _useState4 = _slicedToArray(_useState3, 2),
    isDesktopView = _useState4[0],
    setDesktopView = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFilterAndSearchModalOpen = _useState6[0],
    setFilterAndSearchModalOpen = _useState6[1];
  var currency = propertyCardProps.currency,
    currencyDisplay = propertyCardProps.currencyDisplay;
  useEffect(function () {
    if (propertiesLayoutRef.current) {
      setDesktopView(propertiesLayoutWidth >= 768);
    }
  }, [propertiesLayoutRef, propertiesLayoutWidth]);
  useEffect(function () {
    if (displayMode) {
      setCurrentLayout(displayMode);
    }
  }, [displayMode]);
  function handleOnChangePage(page) {
    // Necessary to inject the widget id and pass it to the container function
    onChangePage(page, widgetId);
  }
  function getSortButtonLabel() {
    if (!showFilters) {
      return '';
    }
    if (sortByMenuItems) {
      return labelsMapLayout.sortAndFilterButton;
    }
    return labelsMapLayout.filterButton;
  }
  var totalResults = pagination === null || pagination === void 0 ? void 0 : pagination.totalResults;
  var LayoutTrigger = function LayoutTrigger(_ref) {
    var layout = _ref.layout,
      customClassName = _ref.customClassName,
      icon = _ref.icon,
      label = _ref.label;
    return /*#__PURE__*/React__default.createElement(Popup, {
      trigger: /*#__PURE__*/React__default.createElement("span", {
        className: "bf-properties-layout-trigger ".concat(customClassName, " ").concat(currentLayout === layout ? 'is-active' : ''),
        onClick: function onClick() {
          return setCurrentLayout(layout);
        },
        "data-test-id": customClassName
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: icon,
        size: "medium"
      })),
      content: label,
      verticalPosition: "bottom"
    });
  };
  LayoutTrigger.defaultProps = {
    customClassName: ''
  };
  LayoutTrigger.propTypes = {
    layout: PropTypes.string.isRequired,
    customClassName: PropTypes.string,
    icon: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
  };
  var showLayoutSwitcher = selectorViewAvailable && availableLayouts.length > 1;
  var noOffers = !(availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length) || error || isLoading;
  var showPropertiesToolbar = !noOffers || (notAvailableProperties === null || notAvailableProperties === void 0 ? void 0 : notAvailableProperties.length) > 0;
  var getDropdownHighlightedItem = function getDropdownHighlightedItem() {
    var foundMenuItem = sortByMenuItems.find(function (element) {
      return element.value === sortBy;
    });
    return foundMenuItem ? foundMenuItem.content : sortByMenuItems[0].content;
  };
  var getPortalFiltersComponent = function getPortalFiltersComponent(isTransparent) {
    var portalFilterLabels = {
      title: filterDataAndLabels.filterTitle,
      searchLabel: filterDataAndLabels.searchLabel,
      searchInputCategory: filterDataAndLabels.searchInputCategoriesLabels,
      searchInputNotFound: filterDataAndLabels.searchInputIntlNotFindMessage,
      alternativeDatesTitle: filterDataAndLabels.alternativeDatesTitle,
      alternativeDatesCheckbox: filterDataAndLabels.alternativeDatesCheckbox,
      priceRange: filterDataAndLabels.priceRangeLabel,
      countries: filterDataAndLabels.countryLabel,
      mealPlans: filterDataAndLabels.mealPlanLabel,
      propertyTypes: filterDataAndLabels.propertyTypeLabel,
      showMore: filterDataAndLabels.showMore,
      showLess: filterDataAndLabels.showLess
    };
    return /*#__PURE__*/React__default.createElement(PortalFilters, {
      language: language,
      isLoading: isLoading,
      labels: portalFilterLabels,
      filterData: filters,
      portalFilters: portalFilters,
      autocompleteFilterApplied: autocompleteFilterApplied,
      onFilterProperties: onFilterProperties,
      showAlternativeOffers: showAlternativeOffers,
      onChangeSearchInput: onChangeSearchInput,
      resetAutocompleteFilters: resetAutocompleteFilters,
      setAutocompleteFilter: setAutocompleteFilter,
      onGetPlace: onGetPlace,
      alternativeOffersConfig: alternativeOffersConfig,
      toggleAlternativeOffers: toggleAlternativeOffers,
      priceRangeMin: priceRangeMin ? Math.floor(priceRangeMin) : 0,
      priceRangeMax: priceRangeMax ? Math.ceil(priceRangeMax) : 0,
      currency: currency,
      currencyDisplay: currencyDisplay,
      onFilterPrice: onFilterPrice,
      onFilterCheckboxes: onFilterCheckboxes,
      transparent: isTransparent
    });
  };
  var mobileSidebar = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, sortByMenuItems ? /*#__PURE__*/React__default.createElement(Card, {
    title: feedbackMessages.sortByLabel,
    titleSize: "medium",
    transparent: true
  }, /*#__PURE__*/React__default.createElement(DropdownMenu, {
    trigger: /*#__PURE__*/React__default.createElement("div", {
      className: "bf-properties-layout-sort-trigger"
    }, getDropdownHighlightedItem()),
    menuItems: sortByMenuItems,
    alignToRight: true,
    menuFullWidth: true
  })) : null, sortByMenuItems && showFilters ? /*#__PURE__*/React__default.createElement(Divider, {
    space: ""
  }) : null, showFilters ? getPortalFiltersComponent(true) : null);
  function getMobileSidebarButtons() {
    var applyButton = /*#__PURE__*/React__default.createElement(Button, {
      primary: true,
      fluid: true,
      size: "medium",
      onClick: function onClick() {
        setFilterAndSearchModalOpen(false);
      },
      className: "sort-button sort-button-apply"
    }, filterDataAndLabels.applyLabel);
    return applyButton;
  }
  var showOffers = !!(!error && !isLoading);
  var sortButtonLabel = getSortButtonLabel();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-main-wrapper ".concat(className),
    ref: propertiesLayoutRef
  }, showFilters && isDesktopView ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-filters-wrapper"
  }, getPortalFiltersComponent(false)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-properties-list-wrapper"
  }, showPropertiesToolbar ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-toolbar-wrapper"
  }, sortByMenuItems && (isDesktopView || !showFilters) ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-sort-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-sort-label"
  }, feedbackMessages.sortByLabel), /*#__PURE__*/React__default.createElement(DropdownMenu, {
    trigger: /*#__PURE__*/React__default.createElement("div", {
      className: "bf-properties-layout-sort-trigger"
    }, getDropdownHighlightedItem()),
    menuItems: sortByMenuItems,
    alignToRight: true,
    menuFullWidth: true
  })) : null, showFilters && !isDesktopView && !isLoading ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-list-filters-in-modal-wrapper"
  }, /*#__PURE__*/React__default.createElement(Modal, {
    externalOpen: isFilterAndSearchModalOpen,
    onOpen: function onOpen() {
      return setFilterAndSearchModalOpen(true);
    },
    onClose: function onClose() {
      return setFilterAndSearchModalOpen(false);
    },
    title: sortButtonLabel,
    className: "bf-properties-list-filters-in-modal",
    content: mobileSidebar,
    trigger: /*#__PURE__*/React__default.createElement(Button, {
      secondary: true,
      fluid: true,
      size: "normal",
      content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
        name: "bf-icon-options",
        size: "normal",
        className: "margin-right-small"
      }), sortButtonLabel)
    }),
    hideCloseOnFooter: true,
    footer: getMobileSidebarButtons()
  })) : null, showLayoutSwitcher ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-configuration-wrapper"
  }, isDesktopView || !showFilters && !sortByMenuItems ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-configuration-wrapper-label"
  }, viewAsLabel) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-triggers-wrapper"
  }, availableLayouts.includes('list') && /*#__PURE__*/React__default.createElement(LayoutTrigger, {
    layout: "list",
    customClassName: "bf-properties-layout-list-trigger",
    icon: "bf-icon-grid-rows",
    label: "List"
  }), availableLayouts.includes('grid') && /*#__PURE__*/React__default.createElement(LayoutTrigger, {
    layout: "grid",
    customClassName: "bf-properties-layout-grid-trigger",
    "data-test-id": "bf-properties-layout-grid-trigger",
    icon: "bf-icon-grid",
    label: "Grid"
  }), availableLayouts.includes('map') && /*#__PURE__*/React__default.createElement(LayoutTrigger, {
    layout: "map",
    customClassName: "bf-properties-layout-map-trigger",
    "data-test-id": "bf-properties-layout-map-trigger",
    icon: "bf-icon-map-marker",
    label: "Map"
  }))) : null) : null, showOffers ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-layout-wrapper property-list-main-column"
  }, currentLayout !== 'map' ? /*#__PURE__*/React__default.createElement(PropertiesList, {
    displayMode: currentLayout,
    alternativeGrid: alternativeGrid,
    propertyCardProps: propertyCardProps,
    availableProperties: availableProperties,
    notAvailableProperties: notAvailableProperties,
    language: language,
    isLoading: isLoading,
    showFeedbackMessage: true,
    feedbackMessages: feedbackMessages,
    onClick: onClick,
    params: params,
    domain: domain,
    getQueryString: getQueryString,
    trustYou: trustYou,
    styledPrice: styledPrice,
    priceMessages: priceMessages,
    onPropertiesRendered: onPropertiesRendered,
    userCountry: userCountry,
    isQA: isQA,
    hidePrices: hidePrices,
    hidePricesMessage: hidePricesMessage,
    alternativeOffersLabels: alternativeOffersLabels,
    intl: intl
  }) : /*#__PURE__*/React__default.createElement(MapLayoutGoogle, {
    propertyCardProps: propertyCardProps,
    labelsMapLayout: labelsMapLayout,
    availableProperties: availableProperties,
    notAvailableProperties: notAvailableProperties,
    language: language,
    onClick: onClick,
    params: params,
    domain: domain,
    getQueryString: getQueryString,
    trustYou: trustYou,
    feedbackMessages: feedbackMessages,
    styledPrice: styledPrice,
    priceMessages: priceMessages,
    intl: intl
  }), totalResults > 10 && /*#__PURE__*/React__default.createElement(Paginator, _extends({
    onChangePage: handleOnChangePage,
    onChangePageSize: onChangePageSize,
    referenceLabel: paginatorReferenceLabel,
    pageSizeMessage: paginatorPageSizeMessage
  }, pagination))) : null));
}
PropertiesLayout.defaultProps = {
  displayMode: 'list',
  alternativeGrid: false,
  className: '',
  availableLayouts: ['list', 'grid', 'map'],
  availableProperties: [],
  notAvailableProperties: [],
  language: '',
  params: {},
  getQueryString: function getQueryString() {},
  onClick: function onClick() {},
  trustYou: null,
  selectorViewAvailable: false,
  styledPrice: false,
  onChangePage: function onChangePage() {},
  onChangePageSize: function onChangePageSize() {},
  paginatorReferenceLabel: {},
  paginatorPageSizeMessage: {},
  pagination: {},
  sortBy: null,
  sortByMenuItems: null,
  viewAsLabel: 'View as',
  priceRangeMin: null,
  priceRangeMax: null,
  autocompleteFilterApplied: null,
  showFilters: false,
  widgetId: '',
  onPropertiesRendered: null,
  onGetPlace: function onGetPlace() {
    return {
      location: {
        latitude: null,
        longitude: null
      },
      distance: null
    };
  },
  isQA: true,
  hidePrices: false,
  hidePricesMessage: null,
  alternativeOffersConfig: undefined,
  showAlternativeOffers: false,
  toggleAlternativeOffers: function toggleAlternativeOffers() {}
};
PropertiesLayout.propTypes = {
  /**
  Show properties in list, grid or map mode
   */
  displayMode: PropTypes.oneOf(['list', 'grid', 'map']),
  /**
  Force alternative layout in grid mode (Echo)
   */
  alternativeGrid: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Available layouts
   */
  availableLayouts: PropTypes.arrayOf(PropTypes.string),
  /**
  Intl labels text
   */
  labelsMapLayout: PropTypes.shape({
    propertiesCurrentSearch: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    availableIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    notAvailableIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    availableAnd: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    filterButton: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    sortAndFilterButton: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
  }).isRequired,
  /**
  Config props to propertyCard
   */
  propertyCardProps: PropTypes.shape({
    currency: PropTypes.shape(currencyShape).isRequired,
    currencyDisplay: PropTypes.string.isRequired,
    mapProvider: PropTypes.elementType.isRequired
  }).isRequired,
  /**
  Array of available properties
   */
  availableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  Array of not available properties
   */
  notAvailableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  Current language
   */
  language: PropTypes.string,
  /**
  Property in loading state
   */
  isLoading: PropTypes.bool.isRequired,
  /**
  Error with the connection or another issue
   */
  error: PropTypes.bool.isRequired,
  /**
  Intl feedback messages
   */
  feedbackMessages: PropTypes.shape(feedbackMessagesShape).isRequired,
  /**
  Site domain
   */
  domain: PropTypes.string.isRequired,
  /**
  Url params
   */
  params: PropTypes.shape(formattedSearchParamsShape),
  /**
  Function helper to get the redirect url
   */
  getQueryString: PropTypes.func,
  /**
  Function triggered on property selection
   */
  onClick: PropTypes.func,
  /**
  Dictionary of trustYou profiles and reviews
   */
  trustYou: PropTypes.objectOf(PropTypes.shape(trustYouReducerShape)),
  /**
  Handle the layout selector
   */
  selectorViewAvailable: PropTypes.bool,
  /**
  Show the price styled (currency, integer, decimal)
   */
  styledPrice: PropTypes.bool,
  /**
  Show the price messages
   */
  priceMessages: PropTypes.shape({
    startingFrom: nodeOrStringProp,
    priceDisplayMode: nodeOrStringProp
  }).isRequired,
  /**
  Widget id
   */
  widgetId: PropTypes.string,
  /**
  Handle page in pagination component
   */
  onChangePage: PropTypes.func,
  /**
  Handle page size in pagination component
   */
  onChangePageSize: PropTypes.func,
  /**
  Reference message in pagination component
   */
  paginatorReferenceLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
  Page Size message in pagination component
   */
  paginatorPageSizeMessage: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
  Pagination component data
   */
  pagination: PropTypes.shape(paginationShape),
  /**
  Actual sortBy value or null for 'recommended'
   */
  sortBy: PropTypes.string,
  /**
  Menu options for sortBy with sortBy values, status and onClick functions
   */
  sortByMenuItems: PropTypes.arrayOf(sortByMenuItemShape),
  /**
  View as label
   */
  viewAsLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
  Min price in availableProperties array
   */
  priceRangeMin: PropTypes.number,
  /**
  Max price in availableProperties array
   */
  priceRangeMax: PropTypes.number,
  /**
  Get new properties with filter applied
   */
  onFilterProperties: PropTypes.func.isRequired,
  /**
  Handle the autocomplete input
   */
  onChangeSearchInput: PropTypes.func.isRequired,
  /**
  Handle the price slider
   */
  onFilterPrice: PropTypes.func.isRequired,
  /**
  Handle the checkboxes filters
   */
  onFilterCheckboxes: PropTypes.func.isRequired,
  /**
  Delete the autocomplete filter applied
   */
  resetAutocompleteFilters: PropTypes.func.isRequired,
  /**
  Set autocomplete filter in state
   */
  setAutocompleteFilter: PropTypes.func.isRequired,
  /**
  Autocomplete filter applied
   */
  autocompleteFilterApplied: PropTypes.string,
  /**
  Filters applied
   */
  filters: PropTypes.shape(propertiesFiltersShape).isRequired,
  /**
  Show filters
   */
  showFilters: PropTypes.bool,
  /**
  Data and filters labels
   */
  filterDataAndLabels: PropTypes.shape().isRequired,
  /**
   * The property list can run a function, passing it the number of available rendered hotels
   */
  onPropertiesRendered: PropTypes.func,
  userCountry: PropTypes.string.isRequired,
  /**
   * This function is executed when there is a search using google maps
   */
  onGetPlace: PropTypes.func,
  /**
   * This value is used for data-test-id, default in true for Widget (TO-DO: Implement data-test-id in widget)
   */
  isQA: PropTypes.bool,
  hidePrices: PropTypes.bool,
  hidePricesMessage: PropTypes.node,
  portalFilters: portalFiltersShape.isRequired,
  alternativeOffersConfig: alternativeOffersShape,
  showAlternativeOffers: PropTypes.bool,
  toggleAlternativeOffers: PropTypes.func,
  alternativeOffersLabels: alternativeOffersLabelsShape.isRequired,
  intl: PropTypes.object.isRequired
};

export default PropertiesLayout;
//# sourceMappingURL=PropertiesLayout.js.map
